import _ from 'lodash'
import {
    DASHBOARD_DATA_REQUEST,
    DASHBOARD_DATA_SUCCESS,
    DASHBOARD_DATA_FAILURE
} from '../actions/index'

// dataByElement and dataIsFetching are keyed by groupModelId then by element id:
// static elements share the same id in every group, so data must never be shared across groupModels
const user = (
    state = {
        elements: [],
        elementsAreFetching: false,
        dataByElement: {},
        dataIsFetching: {},
        dashboardFetchingError: null,
        dataFetchingErrors: []
    },
    action
) => {
    switch (action.type) {
        case DASHBOARD_DATA_REQUEST:
            return {
                ...state,
                dataIsFetching: {
                    ...state.dataIsFetching,
                    [action.groupModelId]: {
                        ...state.dataIsFetching[action.groupModelId],
                        [action.id]: true
                    }
                }
            }
        case DASHBOARD_DATA_SUCCESS:
            const dataObject = action.data[0]
            return {
                ...state,
                dataIsFetching: {
                    ...state.dataIsFetching,
                    [action.groupModelId]: {
                        ...state.dataIsFetching[action.groupModelId],
                        [action.id]: false
                    }
                },
                dataByElement: {
                    ...state.dataByElement,
                    [action.groupModelId]: {
                        ...state.dataByElement[action.groupModelId],
                        [dataObject.id]: {
                            ...dataObject
                        }
                    }
                }
            }
        case DASHBOARD_DATA_FAILURE:
            return {
                ...state,
                dataIsFetching: {
                    ...state.dataIsFetching,
                    [action.groupModelId]: {
                        ...state.dataIsFetching[action.groupModelId],
                        [action.id]: false
                    }
                },
                dataByElement: {
                    ...state.dataByElement,
                    [action.groupModelId]: _.omit(state.dataByElement[action.groupModelId], action.id)
                },
                dataFetchingErrors: [
                    ...state.dataFetchingErrors,
                    action.error
                ]
            }

        default:
            return state
    }
}

export default user